import { render, staticRenderFns } from "./ProfileAvatar.vue?vue&type=template&id=2533cef0&"
import script from "./ProfileAvatar.vue?vue&type=script&lang=js&"
export * from "./ProfileAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAvatar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports